// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shadowCard[data-v-69896981] {\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n  border: 0.5px solid transparent;\n}\n", ""]);
// Exports
module.exports = exports;
